import { CSSProperties, FC, useMemo } from 'react'

import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { flexRender, Row } from '@tanstack/react-table'

import { IBreakRegistrationByDay } from '../../../../../../../models/events/event.interface'
import { MANAGE_OPERATIONS_CONSTS } from '../../../../data/operations.data.const'

interface DraggableRiderRowProps {
  tableRow: Row<IBreakRegistrationByDay>
  isLastChild: boolean
  isEditMode: boolean
  hasClash: boolean
}

export const DraggableRiderRow: FC<DraggableRiderRowProps> = ({
  tableRow,
  isLastChild,
  isEditMode,
  hasClash,
}) => {
  const rowData = tableRow.original

  const { transform, transition, setNodeRef, attributes, listeners, isDragging } = useSortable({
    id: rowData.id,
  })

  const style: CSSProperties = useMemo(() => {
    return {
      transform: CSS.Transform.toString(transform),
      transition,
      opacity: isDragging ? 0.8 : 1,
      position: 'relative',
      zIndex: isDragging ? 30 : 'auto',
      borderBottom: !isLastChild ? '1px solid rgb(233, 236, 239)' : 'none',
      minHeight: '72px',
      height: '70px',
      overflow: 'auto',
    }
  }, [transform, transition, isDragging, isLastChild])

  return (
    <tr ref={setNodeRef} style={style}>
      {tableRow.getVisibleCells().map((cell) => {
        const columnId = cell.id.split('_')[1] || cell.id
        const width = MANAGE_OPERATIONS_CONSTS.RIDER_COLUMNS_WIDTH[columnId]

        return (
          <td
            key={cell.id}
            style={{
              width: width,
              paddingTop: '8px',
              paddingBottom: '8px',
              verticalAlign: 'middle',
            }}
          >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </td>
        )
      })}
      {isEditMode && (
        <td
          style={{
            width: MANAGE_OPERATIONS_CONSTS.RIDER_COLUMNS_WIDTH['drag'],
            paddingTop: '8px',
            paddingBottom: '8px',
            verticalAlign: 'middle',
          }}
        >
          <div className="flex items-center justify-center gap-2">
            <div className="flex items-center justify-center gap-2">
              <div
                className="drag-handle flex justify-center flex-shrink-0 cursor-grab active:cursor-grabbing p-2 hover:opacity-70 transition-all"
                {...attributes}
                {...listeners}
              >
                <img
                  src={
                    hasClash && !rowData.orderOfGoScratched
                      ? '/assets/cp_icons/grip-vertical-red.svg'
                      : '/assets/cp_icons/grip-vertical.svg'
                  }
                  alt="Drag Icon"
                  className="h-6 w-6"
                />
              </div>
            </div>
          </div>
        </td>
      )}
    </tr>
  )
}
